import { useState, useEffect } from 'react';
import { splitToken } from 'dibs-cookie-jar/exports/splitToken';
import { getBuyerId } from 'dibs-cookie-jar';
import { datadog } from 'dibs-datadog/exports/datadog';
import { useLoggedInUser } from 'dibs-buyer-layout/exports/useLoggedInUser';

let guestUserToken: string | undefined;

type Callback = () => void;
const cbs: Callback[] = [];

function addGuestLoginHandler(cb: Callback): void {
    cbs.push(cb);
}

export function getGuestUserToken(): string | undefined {
    const buyerId = getBuyerId(document.cookie);
    if (buyerId) {
        return undefined;
    }
    return guestUserToken;
}

export function getGuestUserId(): string | null {
    const token = getGuestUserToken();
    if (token) {
        return splitToken(token);
    }
    return null;
}

export function setGuestUserToken(token: string | null): void {
    let userId;
    if (token) {
        guestUserToken = token;
        userId = splitToken(token);
    } else {
        guestUserToken = undefined;
    }
    if (userId) {
        datadog.run.setGlobalContextProperty('checkoutGuestUser', true);
        datadog.run.setUser({
            id: userId,
        });
    } else {
        datadog.run.removeGlobalContextProperty('checkoutGuestUser');
        datadog.run.clearUser();
    }
    cbs.forEach(cb => cb());
}

function useGuestUserId(): string | null {
    const [guestUserId, setGuestUserId] = useState<string | null>(null);

    useEffect(() => {
        setGuestUserId(getGuestUserId());

        addGuestLoginHandler(() => {
            setGuestUserId(getGuestUserId());
        });
    }, []);

    return guestUserId;
}

export function useGuestOrLoggedInUserId(): string | null {
    const loggedInUser = useLoggedInUser();
    const guestUser = useGuestUserId();
    return loggedInUser || guestUser || null;
}
